import { render, staticRenderFns } from "./EvaluateExam.vue?vue&type=template&id=15144a6f&"
import script from "./EvaluateExam.vue?vue&type=script&lang=js&"
export * from "./EvaluateExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports